const menuList = [
    {
        name: '招标',
        children: [
            {
                name: '招标代理',
                children: [],
            },
            {
                name: '政府与社会资本合作',
                children: [],
            },
            {
                name: '国有企业招标采购',
                children: [],
            },
            {
                name: '招标进阶',
                children: [],
            },
        ]
    },
    {
        name: '采购',
        children: [
            {
                name: '政府采购类',
                children: [],
            },
            {
                name: '采招知道',
                children: [],
            },
            {
                name: '国有企业招标采购',
                children: [],
            },
            {
                name: '采招人员能力评价',
                children: [],
            },
        ]
    },
    {
        name: '工程',
        children: [
            {
                name: '建设工程',
                children: [],
            },
            {
                name: '评标',
                children: [],
            },
            {
                name: '投标',
                children: [],
            },
        ]
    },
    {
        name: '公共资源',
        children: [
            {
                name: '自然资源',
                children: [
                    {name: '国有产权交易'},
                    {name: '海洋资源交易'},
                    {name: '林权交易'},
                    {name: '农村集体产权交易'}
                ]
            },
            {
                name: '资产股权',
                children: [
                    {name: '无形资产交易'},
                    {name: '司法行政罚没交易'}
                ]
            },
            {
                name: '环境权',
                children: [
                    {name: '排污权交易'},
                    {name: '定额出让排污权'},
                    {name: '公开拍卖排污权'},
                    {name: '碳排放权交易'},
                    {name: '用能权交易'},
                ]
            },
        ]
    },
]
 
export default menuList